import { connect } from 'react-redux';
import { mediaSelectors, callSelectors } from '@lifesize/nucleus';
import { isCallConnected } from 'utils/call-utils';
import MicrophoneDropdown from 'components/MicrophoneDropdown/MicrophoneDropdown';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const isInCall = isCallConnected(activeCall);
  const isWebConferencing = _get(activeCall, 'isWebConferencing');
  const isPSTNVisible = isInCall ? isWebConferencing : _get(state, 'app.joinModal.isPSTNVisible');
  const microphoneDeviceId = _get(mediaSelectors.selectedAudioDevice(state), 'deviceId');
  return {
    audioDevices: mediaSelectors.audioDevices(state) || [],
    isPSTNVisible,
    microphoneDeviceId
  };
};

export default connect(mapStateToProps)(MicrophoneDropdown);
